module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"column col-half component-news-item-list\">\n    <a href=\"<$-link $>\">\n        <figure class=\"img-holder motion\">\n            <img src=\"<$-img $>\" alt=\"\">\n            <div class=\"mask\"></div>\n        </figure>\n        <article class=\"txt-holder motion\">\n            <span class=\"date\"><$-date $></span>\n            <h4 class=\"title\"><$-title $></h4>\n        </article>\n    </a>\n</li>\n")
  }
  return __output;

}